/*
 * custom.js - codice su misura Dalle Piane, portato su Prestige 11 il 12-09-2026.
 *
 * Su Prestige 5 questo file era scritto in jQuery e serviva a due cose: aprire
 * l'elenco dei paesi nell'header e gestire la spunta della confezione regalo.
 * L'11-09-2026 e' stato riscritto in JavaScript nativo e jQuery e' stato tolto
 * dal tema. Prestige 11 non usa jQuery, quindi qui resta la versione nativa.
 *
 * Contiene la confezione regalo e il collegamento alla tabella taglie accanto
 * al selettore. Il selettore paese arrivera' quando si ricostruira' l'header.
 *
 * NOTA STORICA (13-09-2026), utile se un domani la chat sparisce.
 * Per qualche ora qui c'e' stata una rete di sicurezza che caricava lo snippet
 * Zendesk se dopo tre secondi non era ancora arrivato. Serviva perche' la chat
 * non la caricava ne' il tema ne' l'app embed (che risultava acceso ma non
 * produceva niente): la caricava un vecchio script tag a livello negozio che
 * puntava a /t/17/assets/zendesk-embeddable.js, cioe' un file dentro gli asset
 * di un tema del 2022 - e cancellando quel tema la chat sarebbe sparita da
 * tutto il negozio senza un errore.
 * Reinstallando l'app Zendesk l'estensione ha ripreso a funzionare: ora il
 * blocco app stampa lui lo snippet, su questo tema e anche su quello
 * pubblicato, quindi la rete e' diventata codice morto ed e' stata tolta.
 * Se un giorno la chat non compare piu', il primo posto dove guardare e'
 * l'app embed Zendesk nelle impostazioni del tema.
 */

(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /*
   * Ascolto delegato sul documento: le righe del carrello vengono ridisegnate
   * dopo ogni modifica, quindi un listener attaccato direttamente alle caselle
   * si perderebbe al primo aggiornamento. Vale sia per la pagina carrello sia
   * per il carrello a tendina.
   */
  document.addEventListener('change', function (event) {
    var checkbox = event.target.closest('.gift-wrap__checkbox');

    if (checkbox === null) {
      return;
    }

    var wanted = checkbox.checked;
    checkbox.disabled = true;

    var action = wanted
      ? addGiftWrap(checkbox.dataset.giftVariant, checkbox.dataset.targetVariant, checkbox.dataset.targetTitle)
      : removeGiftWrap(checkbox.dataset.targetVariant);

    action
      .then(function () {
        refreshCart();
      })
      .catch(function (error) {
        // Se la chiamata fallisce si riporta la casella allo stato precedente,
        // altrimenti mostrerebbe una confezione che nel carrello non c'e'.
        console.error('[confezione regalo]', error);
        checkbox.checked = !wanted;
        checkbox.disabled = false;
      });
  });

  /*
   * Come aggiorna Prestige 11 dopo una modifica al carrello.
   *
   * cart:refresh e' ascoltato dal contatore, dal pallino e dal carrello a
   * tendina, ma NON dalla sezione della pagina carrello, che si aggiorna solo
   * via cart:change con il carrello gia' in mano oppure con il rendering delle
   * sezioni. Verificato dentro theme.js della 11.4.0: nel codice del codice
   * sconto il tema fa esattamente questo, cioe' emette cart:refresh e, se si
   * trova sulla pagina carrello, ricarica. Qui si fa lo stesso, per non
   * lasciare la casella della pagina spuntata su un carrello che nel frattempo
   * e' cambiato.
   */
  function refreshCart() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

    var pageType = window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType;

    if (pageType === 'cart') {
      window.location.reload();
    }
  }

  function addGiftWrap(giftVariantId, targetVariantId, targetTitle) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [
          {
            id: Number(giftVariantId),
            quantity: 1,
            properties: {
              _variant_id: String(targetVariantId),
              'Geschenkverpackung für': targetTitle
            }
          }
        ]
      })
    }).then(checkResponse);
  }

  function removeGiftWrap(targetVariantId) {
    return fetch(root + 'cart.js')
      .then(checkResponse)
      .then(function (cart) {
        var line = cart.items.filter(function (item) {
          return item.properties && String(item.properties._variant_id) === String(targetVariantId);
        })[0];

        if (!line) {
          return null; // gia' rimossa altrove: non e' un errore
        }

        return fetch(root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: 0 })
        }).then(checkResponse);
      });
  }

  function checkResponse(response) {
    if (!response.ok) {
      return response.text().then(function (body) {
        throw new Error(response.status + ' ' + body.slice(0, 200));
      });
    }

    return response.json();
  }

  /* 17-09-2026 - Rimosso il troncamento "Mehr lesen" della descrizione: le descrizioni riscritte sono brevi e il meccanismo non era usato dal blog. */

  /* ----------------------------------------------------------------
   * 13-09-2026 - Tabella taglie accanto al selettore.
   *
   * L'app Best Fit stampa il suo pulsante dentro il blocco del pulsante
   * di acquisto, cioe' SOTTO "Aggiungi al carrello". Ma il dubbio sulla
   * taglia viene al cliente mentre guarda le caselle, non dopo che ha
   * deciso di comprare: qui, sulla riga dell'etichetta "Taglia", viene
   * aggiunto un collegamento che apre la stessa tabella, e quello
   * dell'app viene nascosto dal CSS.
   *
   * PERCHE' NON SI SPOSTA IL PULSANTE DELL'APP
   * Primo tentativo, poi abbandonato: si spostava il nodo dell'app
   * dentro la riga della taglia. Non funziona per due motivi che si
   * sommano. Al cambio variante Prestige RIGENERA tutto
   * <variant-picker> (verificato: il nodo non sopravvive), e l'app si
   * accorge che il suo elemento e' stato mosso e lo rimette a posto o
   * lo toglie: il risultato osservato e' stato che la tabella taglie
   * spariva del tutto. Meglio non contendersi un nodo che appartiene a
   * qualcun altro: si lascia il suo dov'e' e si aggiunge il nostro.
   *
   * Il collegamento nostro sta dentro il selettore, quindi anche lui
   * viene distrutto a ogni cambio variante: lo rimette l'osservatore
   * qui sotto, ed e' un elemento che costa nulla da ricreare.
   *
   * La riga di destinazione e' .variant-picker__option-info, che il tema
   * dispone gia' con etichetta a sinistra e spazio a destra: non serve
   * nessun CSS di posizionamento.
   *
   * Sui prodotti a taglia unica - 66 su 86 - non c'e' nessuna riga
   * "Taglia" e non si tocca niente: resta il pulsante dell'app dov'e'.
   * ---------------------------------------------------------------- */
  var SELETTORE_TABELLA = '.best-fit-size-chart button, .scr-open-size-chart';

  function rigaDellaTaglia() {
    var opzioni = document.querySelectorAll('.variant-picker__option');

    for (var i = 0; i < opzioni.length; i++) {
      var etichetta = opzioni[i].querySelector('legend');

      if (etichetta && /taglia|size|größe|grosse/i.test(etichetta.textContent)) {
        return opzioni[i].querySelector('.variant-picker__option-info');
      }
    }

    return null;
  }

  function creaLinkTaglie() {
    var riga = rigaDellaTaglia();

    if (riga === null || riga.querySelector('.dpc-taglie') !== null) {
      return;
    }

    if (document.querySelector(SELETTORE_TABELLA) === null) {
      return; // l'app non ha ancora stampato il suo pulsante
    }

    var link = document.createElement('button');
    link.type = 'button';
    link.className = 'dpc-taglie';
    link.textContent = 'Größentabelle';

    link.addEventListener('click', function () {
      // si ricerca al momento del clic: fra la creazione e il clic il
      // pulsante dell'app puo' essere stato ristampato
      var originale = document.querySelector(SELETTORE_TABELLA);

      if (originale !== null) {
        originale.click();
      }
    });

    riga.appendChild(link);

    // da qui in poi il CSS nasconde il pulsante dell'app: si accende
    // solo ora, cosi' se qualcosa va storto la tabella resta comunque
    // raggiungibile dal suo posto originale
    document.documentElement.classList.add('dpc-taglie-spostata');
  }

  var timerTaglie = null;

  function osservaTabellaTaglie() {
    creaLinkTaglie();

    var zona = document.querySelector('.product-info') || document.body;

    new MutationObserver(function () {
      clearTimeout(timerTaglie);
      timerTaglie = setTimeout(creaLinkTaglie, 100);
    }).observe(zona, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', osservaTabellaTaglie);
  } else {
    osservaTabellaTaglie();
  }

  /* ----------------------------------------------------------------
   * 15-09-2026 - Trustpilot: ravvivare il widget dopo il cambio variante.
   *
   * Il sintomo, visto cambiando colore su una scheda prodotto: le
   * stelline sparivano e tornavano solo ricaricando la pagina.
   *
   * Perche'. Quando si cambia variante Prestige non ritocca qualche
   * pezzo: si fa restituire da Shopify l'intera colonna informazioni e
   * ne riscrive il contenuto. Il contenitore Trustpilot che c'era,
   * iframe compreso, viene buttato via e al suo posto ne arriva uno
   * nuovo, vuoto. Il caricatore di Trustpilot pero' cerca i widget UNA
   * VOLTA SOLA, al caricamento della pagina, e non sta a guardare se ne
   * compaiono altri: il contenitore nuovo restava vuoto per sempre.
   *
   * La cura. Trustpilot espone loadFromElement(elemento, true) proprio
   * per i widget inseriti dopo il caricamento; il secondo argomento gli
   * dice di rileggere gli attributi data-* dall'elemento invece di
   * usare quelli che ha in memoria.
   *
   * Si ravviva SOLO chi non ha gia' un iframe dentro: altrimenti a ogni
   * mutazione si ricaricherebbero widget gia' funzionanti, con uno
   * sfarfallio e chiamate di rete per niente.
   * ---------------------------------------------------------------- */

  var timerTrustpilot = null;

  function zonaProdotto() {
    var info = document.querySelector('.product-info');

    if (info === null) {
      return null; // non siamo su una scheda prodotto
    }

    // Si osserva la SEZIONE che contiene la colonna, non la colonna: la
    // sezione non viene sostituita quando si cambia variante, ne viene
    // riscritto il contenuto. Agganciarsi a .product-info significa
    // ritrovarsi, dopo il primo cambio colore, un osservatore attaccato a
    // un nodo ormai staccato dalla pagina, che non segnala piu' niente.
    return info.closest('[id^="shopify-section-"]') || document.body;
  }

  function ravvivaTrustpilot() {
    if (!window.Trustpilot || typeof window.Trustpilot.loadFromElement !== 'function') {
      return; // il caricatore dell'app non e' (ancora) in pagina
    }

    var widget = document.querySelectorAll('.trustpilot-widget');

    for (var i = 0; i < widget.length; i++) {
      if (widget[i].querySelector('iframe') === null) {
        window.Trustpilot.loadFromElement(widget[i], true);
      }
    }
  }

  function chiediRavvivamento() {
    clearTimeout(timerTrustpilot);
    timerTrustpilot = setTimeout(ravvivaTrustpilot, 150);
  }

  function osservaTrustpilot() {
    var zona = zonaProdotto();

    if (zona === null) {
      return;
    }

    new MutationObserver(chiediRavvivamento).observe(zona, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', osservaTrustpilot);
  } else {
    osservaTrustpilot();
  }

  // L'editor del tema ridisegna la sezione a ogni modifica: senza questo,
  // lavorando nell'editor le stelline sparirebbero al primo ritocco.
  document.addEventListener('shopify:section:load', chiediRavvivamento);

  /* ----------------------------------------------------------------
   * 14-09-2026 - Confezione regalo rimasta orfana.
   *
   * Ogni riga "confezione regalo" porta la proprieta' nascosta
   * _variant_id con l'id della variante a cui e' agganciata. Se il
   * cliente toglie il capo ma lascia la confezione, nel carrello
   * resterebbe una scatola da sola: non la vendiamo, e non ha
   * nemmeno senso spedirla.
   *
   * Qui, dopo ogni modifica al carrello, si rileggono le righe e si
   * tolgono quelle il cui capo non c'e' piu'. Vale anche per la
   * quantita' portata a zero, che per Shopify e' una rimozione.
   *
   * Due paracadute: un interruttore per non rientrare mentre la
   * pulizia e' in corso, e un ricaricamento al massimo per volta,
   * cosi' un caso imprevisto non manda la pagina carrello in un
   * ciclo di ricariche.
   * ---------------------------------------------------------------- */
  var puliziaInCorso = false;
  var giaRicaricato = false;

  function pulisciConfezioniOrfane() {
    if (puliziaInCorso) {
      return Promise.resolve(false);
    }

    puliziaInCorso = true;

    return fetch(root + 'cart.js')
      .then(checkResponse)
      .then(function (cart) {
        var presenti = {};

        cart.items.forEach(function (item) {
          presenti[String(item.variant_id)] = true;
        });

        var orfane = cart.items.filter(function (item) {
          var legame = item.properties && item.properties._variant_id;
          return legame && !presenti[String(legame)];
        });

        if (orfane.length === 0) {
          return false;
        }

        // una alla volta: /cart/change.js rinumera le chiavi a ogni scrittura
        return orfane
          .reduce(function (catena, riga) {
            return catena.then(function () {
              return fetch(root + 'cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: riga.key, quantity: 0 })
              }).then(checkResponse);
            });
          }, Promise.resolve())
          .then(function () {
            return true;
          });
      })
      .then(function (rimosse) {
        puliziaInCorso = false;

        if (rimosse) {
          var pageType = window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType;

          if (pageType === 'cart' && !giaRicaricato) {
            giaRicaricato = true;
            window.location.reload();
          } else {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          }
        }

        return rimosse;
      })
      .catch(function (error) {
        puliziaInCorso = false;
        console.error('[confezione regalo] pulizia', error);
        return false;
      });
  }

  document.documentElement.addEventListener('cart:refresh', function () {
    pulisciConfezioniOrfane();
  });

  document.documentElement.addEventListener('cart:change', function () {
    pulisciConfezioniOrfane();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pulisciConfezioniOrfane);
  } else {
    pulisciConfezioniOrfane();
  }

  /* ----------------------------------------------------------------
   * 14-09-2026 - Messaggio di auguri.
   *
   * Il testo viene salvato come proprieta' "Grußtext" SULLA RIGA
   * DELLA CONFEZIONE: cosi' se la confezione viene tolta sparisce
   * anche il messaggio, e in admin si legge accanto alla confezione
   * a cui appartiene.
   *
   * 17-09-2026 - NON PIU' SOLO SULLA RIGA DELLA CONFEZIONE.
   * Sui capi che la scatola ce l'hanno gia' dentro (le due copertine
   * neonato G031 e A392) una riga confezione non esiste, e il
   * messaggio si attacca alla riga del capo. Qui dentro non cambia
   * niente: su quale riga scrivere arriva sempre da data-line-key, ed
   * e' gift-wrap.liquid a deciderlo. Cambia invece come si ritrova la
   * riga DOPO il salvataggio - vedi piu' sotto, e' il punto delicato.
   *
   * Si salva quando il campo perde il fuoco, non a ogni tasto: sono
   * chiamate di rete, non vale la pena farne una per lettera.
   *
   * ATTENZIONE: /cart/change.js CAMBIA LA CHIAVE della riga quando ne
   * cambiano le proprieta'. Dopo il salvataggio bisogna quindi
   * rileggere la nuova chiave dalla risposta, altrimenti il secondo
   * salvataggio scrive su una riga che non esiste piu'. E' il motivo
   * per cui qui non si ricarica la pagina: il totale non cambia, e
   * una ricarica a ogni messaggio scritto sarebbe fastidiosa.
   *
   * Sulla pagina carrello lo snippet esce due volte per la stessa
   * riga (pagina piu' tendina), quindi dopo il salvataggio si
   * allineano anche le altre caselle che puntano alla stessa riga.
   * ---------------------------------------------------------------- */
  function campiDellaStessaRiga(chiave) {
    return Array.prototype.slice
      .call(document.querySelectorAll('[data-gift-message]'))
      .filter(function (campo) {
        return campo.dataset.lineKey === chiave;
      });
  }

  function aggiornaContatore(campo) {
    var piede = campo.parentElement.querySelector('[data-gift-message-count]');

    if (piede) {
      piede.textContent = campo.value.length + '/' + (campo.maxLength > 0 ? campo.maxLength : 200);
    }
  }

  function mostraStato(campo, testo) {
    var stato = campo.parentElement.querySelector('[data-gift-message-status]');

    if (!stato) {
      return;
    }

    stato.textContent = testo;

    if (testo) {
      window.setTimeout(function () {
        stato.textContent = '';
      }, 2500);
    }
  }

  function salvaMessaggio(campo) {
    var chiave = campo.dataset.lineKey;
    var testo = campo.value.trim();

    if (!chiave || campo.dataset.ultimoSalvato === testo) {
      return;
    }

    campo.dataset.ultimoSalvato = testo;

    fetch(root + 'cart.js')
      .then(checkResponse)
      .then(function (cart) {
        var riga = cart.items.filter(function (item) {
          return item.key === chiave;
        })[0];

        if (!riga) {
          return null;
        }

        // si riscrivono TUTTE le proprieta': change.js sostituisce il gruppo,
        // non lo aggiorna, quindi omettere _variant_id spezzerebbe il legame
        var proprieta = {};

        Object.keys(riga.properties || {}).forEach(function (nome) {
          proprieta[nome] = riga.properties[nome];
        });

        if (testo) {
          proprieta['Grußtext'] = testo;
        } else {
          delete proprieta['Grußtext'];
        }

        return fetch(root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: chiave, properties: proprieta })
        }).then(checkResponse);
      })
      .then(function (cart) {
        if (!cart) {
          return;
        }

        /*
         * 17-09-2026 - LA RIGA SI RITROVA DALLA VARIANTE, NON DALLA VECCHIA CHIAVE.
         *
         * change.js cambia la chiave a ogni scrittura di proprieta'. Il codice
         * di prima cercava il legame _variant_id partendo dalla chiave VECCHIA,
         * che nel carrello appena tornato non esiste piu': legame restava
         * sempre null. Finche' si scrive un testo il difetto non si vede,
         * perche' basta il confronto sul testo; ma CANCELLANDO il messaggio non
         * si trovava piu' niente, il campo restava agganciato a una chiave
         * morta e il messaggio scritto subito dopo non si salvava, senza
         * nessun errore a schermo.
         *
         * Ora la riga si riconosce da quello che non cambia, cioe' la variante.
         * Il confronto sul legame serve a distinguere due righe confezione
         * della stessa scatola agganciate a capi diversi; sulle righe normali,
         * dove il legame non c'e', si pretende che non ci sia, altrimenti una
         * copertina potrebbe farsi passare per la confezione di qualcun altro.
         */
        var variante = campo.dataset.lineVariant;
        var legame = campo.dataset.lineTarget;

        var nuova = cart.items.filter(function (item) {
          var p = item.properties || {};

          if (variante && String(item.variant_id) !== String(variante)) {
            return false;
          }

          if (legame) {
            if (String(p._variant_id || '') !== String(legame)) {
              return false;
            }
          } else if (p._variant_id) {
            return false;
          }

          return testo ? p['Grußtext'] === testo : !p['Grußtext'];
        })[0];

        if (nuova) {
          campiDellaStessaRiga(chiave).forEach(function (altro) {
            altro.dataset.lineKey = nuova.key;
            if (altro !== campo) {
              altro.value = testo;
              aggiornaContatore(altro);
            }
          });
        }

        mostraStato(campo, 'Grußtext gespeichert');
      })
      .catch(function (error) {
        console.error('[messaggio di auguri]', error);
        campo.dataset.ultimoSalvato = '';
        mostraStato(campo, 'Speichern fehlgeschlagen, bitte erneut versuchen');
      });
  }

  document.addEventListener('input', function (event) {
    var campo = event.target.closest('[data-gift-message]');

    if (campo) {
      aggiornaContatore(campo);
    }
  });

  document.addEventListener(
    'blur',
    function (event) {
      var campo = event.target.closest('[data-gift-message]');

      if (campo) {
        salvaMessaggio(campo);
      }
    },
    true
  );
})();
/* ----------------------------------------------------------------
 * 25-09-2026 - DATA DI CONSEGNA PREVISTA NELL'ORDINE.
 *
 * Come sull'IT: la data che il cliente vede nel blocco di Essential
 * Estimated (la terza tappa, "Delivered") finisce sulla riga del capo
 * nel carrello e quindi nell'ordine, come proprieta'
 * "Voraussichtliche Zustellung", per esempio 29.09.2026 - 01.10.2026.
 *
 * COME. Il blocco nuovo dell'app mostra la data ma non la scrive nel
 * carrello. Qui si legge il testo della terza tappa
 * (.essential-estimated-delivery-sub-title-3, es. "Sept. 29 - Okt. 01")
 * e lo si mette in un campo nascosto properties[...] dentro ai moduli
 * di acquisto della stessa sezione: cosi' lo prende sia l'aggiunta al
 * carrello di Prestige sia il pagamento rapido, senza toccare il tema.
 *
 * LA DATA E' QUELLA DELL'APP, non ricalcolata: si converte solo il
 * formato (l'app non scrive l'anno). L'anno e' quello corrente, o il
 * successivo se la data sarebbe gia' passata (ordini di fine dicembre).
 * Se il testo non si riesce a leggere si scrive com'e', mai una data
 * inventata.
 *
 * NIENTE CAMPO se il blocco dell'app non si vede (prevendita, esauriti):
 * li' non c'e' una data da promettere.
 *
 * Al cambio variante Prestige riscrive la colonna del prodotto e il
 * campo sparisce: lo rimette l'osservatore, come per la tabella taglie.
 * ---------------------------------------------------------------- */
(function () {
  'use strict';

  var ETICHETTA = 'Voraussichtliche Zustellung';
  var NOME = 'properties[' + ETICHETTA + ']';

  var MESI = {
    jan: 0, feb: 1, mär: 2, mar: 2, apr: 3, mai: 4, jun: 5,
    jul: 6, aug: 7, sep: 8, okt: 9, nov: 10, dez: 11
  };

  function mese(testo) {
    var chiave = testo.toLowerCase().replace(/[^a-zäöü]/g, '').slice(0, 3);
    return Object.prototype.hasOwnProperty.call(MESI, chiave) ? MESI[chiave] : null;
  }

  function dataCompleta(m, g) {
    var oggi = new Date();
    oggi.setHours(0, 0, 0, 0);
    var d = new Date(oggi.getFullYear(), m, g);
    if (d < oggi) {
      d = new Date(oggi.getFullYear() + 1, m, g);
    }
    return d;
  }

  function formato(d) {
    var gg = ('0' + d.getDate()).slice(-2);
    var mm = ('0' + (d.getMonth() + 1)).slice(-2);
    return gg + '.' + mm + '.' + d.getFullYear();
  }

  /* "Sept. 29 - Okt. 01" / "Sept. 29 - 30" / "Sept. 29" */
  function leggiIntervallo(testo) {
    var parti = testo.split(/\s+[-–]\s+/);
    var primo = parti[0].match(/^(\D+?)\s*(\d{1,2})$/);

    if (!primo || mese(primo[1]) === null) {
      return null;
    }

    var m1 = mese(primo[1]);
    var inizio = dataCompleta(m1, Number(primo[2]));

    if (parti.length < 2) {
      return formato(inizio);
    }

    var secondo = parti[1].match(/^(?:(\D+?)\s*)?(\d{1,2})$/);

    if (!secondo) {
      return null;
    }

    var m2 = secondo[1] ? mese(secondo[1]) : m1;

    if (m2 === null) {
      return null;
    }

    var fine = new Date(inizio.getFullYear(), m2, Number(secondo[2]));
    if (fine < inizio) {
      fine = new Date(inizio.getFullYear() + 1, m2, Number(secondo[2]));
    }

    return formato(inizio) + ' - ' + formato(fine);
  }

  function aggiornaCampi() {
    var tappa = document.querySelector('.essential-estimated-delivery-sub-title-3');
    var sezione = tappa ? tappa.closest('[id^="shopify-section-"]') : null;
    var zona = sezione || document;
    var moduli = zona.querySelectorAll('form[action*="/cart/add"]');
    var valore = '';

    if (tappa && tappa.offsetParent !== null) {
      var grezzo = tappa.textContent.replace(/\s+/g, ' ').trim();
      valore = grezzo ? (leggiIntervallo(grezzo) || grezzo) : '';
    }

    for (var i = 0; i < moduli.length; i++) {
      var campo = moduli[i].querySelector('input[data-dpc-consegna]');

      if (!valore) {
        if (campo) {
          campo.parentNode.removeChild(campo);
        }
        continue;
      }

      if (!campo) {
        campo = document.createElement('input');
        campo.type = 'hidden';
        campo.name = NOME;
        campo.setAttribute('data-dpc-consegna', '');
        moduli[i].appendChild(campo);
      }

      if (campo.value !== valore) {
        campo.value = valore;
      }
    }
  }

  var timer = null;

  function chiedi() {
    clearTimeout(timer);
    timer = setTimeout(aggiornaCampi, 150);
  }

  function avvia() {
    // solo sulla scheda prodotto: e' l'unico posto dove c'e' il blocco dell'app
    var tipo = window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType;

    if ((tipo && tipo !== 'product') || !document.querySelector('form[action*="/cart/add"]')) {
      return;
    }

    aggiornaCampi();
    new MutationObserver(chiedi).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avvia);
  } else {
    avvia();
  }

  document.addEventListener('shopify:section:load', chiedi);
})();
